<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Reviews</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Reviews</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Review">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{ name: 'ReviewList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group">
                    <label class="control-label">Star Rating</label>
                    <input
                      type="text"
                      id="star_rating"
                      name="star_rating"
                      v-model="value.star_rating"
                      class="form-control star_rating"
                      placeholder="Star Rating"
                      :readonly="is_edit"
                    />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Class Rating</label>
                    <select
                      class="form-control"
                      style="width: 100%"
                      name="class_rating"
                      v-model="value.class_rating"
                      id="class_rating"
                      :readonly="is_edit"
                    >
                      <option value="too_good">too_good</option>
                      <option value="not_bad">not_bad</option>
                      <option value="stay_away">stay_away</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Review</label>
                    <textarea
                      id="body"
                      name="body"
                      v-model="value.body"
                      class="form-control body"
                      placeholder="Review"
                      rows="3"
                      :readonly="is_edit"
                    ></textarea>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Reply</label>
                    <textarea
                      id="reply"
                      name="reply"
                      v-model="value.reply"
                      class="form-control reply"
                      placeholder="Reply"
                      rows="3"
                    ></textarea>
                  </div>
                  <div class="form-group">
                    <div class="custom-control custom-checkbox">
                      <input
                        class="custom-control-input"
                        v-bind:class="{
                          'has-error': errors.has('approved_star_rating'),
                        }"
                        type="checkbox"
                        :id="'approved_star_rating'"
                        name="approved_star_rating"
                        v-model="value.approved_star_rating"
                      />
                      <label
                        :for="'approved_star_rating'"
                        class="custom-control-label"
                        >Is star rating approved?</label
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="custom-control custom-checkbox">
                      <input
                        class="custom-control-input"
                        v-bind:class="{
                          'has-error': errors.has('approved_class_rating'),
                        }"
                        type="checkbox"
                        :id="'approved_class_rating'"
                        name="approved_class_rating"
                        v-model="value.approved_class_rating"
                      />
                      <label
                        :for="'approved_class_rating'"
                        class="custom-control-label"
                        >Is Class Rating Approved?</label
                      >
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Course</label>
                    <multiselect
                      id="reviewable_id"
                      name="reviewable_id"
                      :options="Object.keys(pre.reviewable_id)"
                      :custom-label="(opt) => pre.reviewable_id[opt]"
                      v-bind:class="{
                        'has-error': errors.has('reviewable_id'),
                      }"
                      v-validate="'required'"
                      v-model="value.reviewable_id"
                      class="reviewable_id"
                      placeholder="Select Reviewable Id"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                    ></multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('reviewable_id')"
                    >
                      {{ errors.first("reviewable_id") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { DepartmentsAPI, CommonAPI } from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "ReviewForm",
  metaInfo: {
    title: "Reviews | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      reviewable_id: {},
    },
  }),
  methods: {
    reviewableIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/8")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/reviews";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/reviews/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "ReviewList" });
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/reviews/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      await this.reviewableIdOptions().then((reviewable_id) => {
        this.pre.reviewable_id = reviewable_id;
      });

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((error) => {
            console.log(error.response);
          });
      }

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
};
</script>
